import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { imgFactionReward } from "@/shared/assets/img";
import { UsersIcon } from "@/shared/icons";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";
import { factionsList } from "@/domains/faction/helpers/factionsList";
import FactionTabsRow from "@/domains/faction/components/FactionTabsRow";
import FactionTaskCard from "@/domains/faction/components/FactionTaskCard";

type Props = {
  faction: FactionEnum;
};

export default function FactionTasksContainer({ faction }: Props) {
  const { t } = useTranslation("faction");

  // TODO ||||| после MVP добавить "monthly"
  // const tabs = useMemo(() => ["daily", "weekly", "monthly"], []);
  const tabs = useMemo(() => ["daily", "weekly"], []);

  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div className="flex flex-col h-full p-6">
      <FactionTabsRow
        title={t("faction.titles.tasks")}
        Icon={UsersIcon}
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        faction={faction}
        i18Path="faction.tasksTabs"
      >
        <div className="w-0.5 h-2.5 ml-3.5 mr-3 bg-white/20 rounded-sm" />
        <p className="text-12 font-bold text-white/70 leading-none uppercase">
          {t("faction.updatingVia")}: <span className="text-white">23ч.34м.</span>
        </p>
      </FactionTabsRow>
      <div className="relative grow inset-0">
        <div className="absolute top-0 left-0 bottom-0 grid grid-cols-3 auto-rows-min gap-[0.9375rem] overflow-x-clip w-[calc(100%+0.9375rem)] pr-[0.6875rem] overflow-y-auto [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]">
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
            isComplete
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
            isComplete
            isNoReward
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
          />
          <FactionTaskCard
            title="Военный медик"
            status="progress"
            description="Используя фракционный дефибриллятор реанимируйте 5 человек из своей фракции"
            currentCount={12}
            maxCount={15}
            url={imgFactionReward}
            faction={faction}
          />
        </div>
      </div>
    </div>
  );
}
